<div class="outlying-top-actions">
    <span class="desk-label"> {{appUtilityService.showDeskName(tab)}} </span>
    <div class="hours-spinner">
        <i class="fa fa-clock-o"></i>
        <p-dropdown [options]="spinnerValueOptions" [tabindex]='tabLevel' [(ngModel)]='spinnerVal' (onChange)="changeSpinnerValue()" styleClass="spinner-values">
            <ng-template let-spinnerValue>
                <div class="p-helper-clearfix">
                    <div> {{spinnerValue.label}} </div>
                </div>
            </ng-template>
        </p-dropdown>
    </div>
    <div class="history-type">
        <span class="display-label">{{outlyingDataLabel.showOutlyingPoints}}</span>
        <div class="selection">
            <p-radioButton labelStyleClass="radio-btn-lable" name="radioBtnOutlayPoints" [tabindex]='tabLevel + 2' value="{{outlyingDataLabel.WTL}}" label="{{outlyingDataLabel.withTrainAndLocomotive}}" [(ngModel)]="displayType" (click)='getValueForDisplayType(outlyingDataLabel.WTL);'></p-radioButton>
            <p-radioButton labelStyleClass="radio-btn-lable" name="radioBtnOutlayPoints" [tabindex]='tabLevel + 4' value="{{outlyingDataLabel.WOTL}}" label="{{outlyingDataLabel.withoutTrainAndLocomotive}}" [(ngModel)]="displayType" (click)='getValueForDisplayType(outlyingDataLabel.WOTL);'></p-radioButton>
            <p-radioButton labelStyleClass="radio-btn-lable" name="radioBtnOutlayPoints" [tabindex]='tabLevel + 6' value="{{outlyingDataLabel.ALL}}" label="{{outlyingDataLabel.ALL}}" [(ngModel)]="displayType" (click)='getValueForDisplayType(outlyingDataLabel.ALL);'></p-radioButton>
        </div>
    </div>
</div>